module.exports = __webpack_public_path__ + "assets/img/karta.a3bdad43.svg";